export enum STEP_ID {
    IDENTIFY = 'identify',
    IDENTITY_RECOVERY = 'IDENTIFY',
    CLIENT_NAME = 'CLIENT_NAME',
    CLIENT_DATA = 'CLIENT_DATA',
    CLIENT_DATA_LINK = 'CLIENT_DATA_LINK',
    CLIENT_ADDRESS = 'CLIENT_ADDRESS',
    CLIENT_ADDRESS_LINK = 'CLIENT_ADDRESS_LINK',
    FRAUD_EMAIL = 'FRAUD_EMAIL',
    FRAUD_FACE = 'FRAUD_FACE',
    FRAUD_SELFIE = 'FRAUD_SELFIE',
    FRAUD_DOC = 'FRAUD_DOC',
    OFFER_PACKAGE = 'OFFER_PACKAGE',
    OFFER_PACKAGE_MATRIX = 'OFFER_PACKAGE_MATRIX',
    OFFER_CARD_LIST = 'OFFER_CARD_LIST',
    OFFER_CARD = 'OFFER_CARD',
    OFFER_CARD_MATRIX = 'OFFER_CARD_MATRIX',
    OFFER_CARD_EXPRESS = 'OFFER_CARD_EXPRESS',
    OFFER_CARD_PACKAGE = 'OFFER_CARD_PACKAGE',
    OFFER_SCP = 'OFFER_SCP',
    OFFER_OVERDRAFT = 'OFFER_OVERDRAFT',
    SECRET_ACCESS = 'SECRET_ACCESS',
    CONFIRMATION = 'CONFIRMATION',
    FINISH = 'FINISH',
    LOAD = 'load',
    OFFER_SALARY_ACCOUNT = "OFFER_SALARY_ACCOUNT",
    RECAP = "RECAP"
}
